import template from './component.tpl.html';
import colors from './../../../../deposits/colors.json';

class ResponseRateController {
    constructor(http, scope, env, $stateParams, $rootScope) {
        this.http = http;
        this.scope = scope;
        this.env = env;
        this.loading = true;
        this.stateParams = $stateParams;
        this.rootScope = $rootScope;
        this.tableIsLoading = false;
        this.init();
        this.resetState();
    }

    init() {
        this.initWatchers();
    }

    initWatchers() {
        this.scope.$watch(() => {
            return this.stateParams.gid
        }, (newVal) => {
            this.updateData();
        });

        this.scope.$watch(() => {
            return this.refresh;
        }, () => {
            if (this.refresh) {
                this.refresh = false;
                this.updateData();
            }
        });

        let that = this;
        this.rootScope.$on('tableIsLoading', function (event, tableIsLoading) {
            that.tableIsLoading = tableIsLoading
        });
    }

    updateData() {
        this.resetState();

        this.http.post(this.env.apiUrl + '/stats/guestlists/stats', {
            guestlist_id: this.stateParams.gid
        }).then((response) => {
            this.data = {...this.data, ...response.data};
            this.resolveResponseRate();
            this.applyAsync();
            this.loading = false;
        }, () => {
            this.loading = false;
            this.error = true;
        });

        this.http.post(this.env.apiUrl + '/stats/messages/undelivered', {
            guestlist_id: this.stateParams.gid
        }).then((response) => {
            //(last_message_state == bounced, blocked, invalid, scheduled, unknown)
            this.data.undelivered_mails = response.data;
            this.loading = false;
        }, () => {
            this.loading = false;
            this.error = true;
        });
    }

    resolveResponseRate() {
        //enum('listed','requested','invited','confirmed','cancelled','waitlisted')
        this.data = {
            ...this.data, ...{
                'listed': 0,
                'requested': 0,
                'invited': 0,
                'confirmed': 0,
                'cancelled': 0,
                'waitlisted': 0,
                'responded': 0,
                'total': 0,
                'checkins': {
                    'pax_planned': 0,
                    'pax_actual': 0
                },
                'confirmedCheckins': {
                    'pax_planned': 0,
                    'pax_actual': 0
                },
                'companions': {
                    'confirmed': 0,
                    'confirmedCheckins': {
                        'pax_planned': 0,
                        'pax_actual': 0
                    }
                }
            }
        };

        this.data.rsvpsData.forEach(function (rsvpData) {
            if (rsvpData.status === 'listed') {
                this.data.listed += parseInt(rsvpData.pax_planned);
            } else if (rsvpData.status === 'requested') {
                this.data.requested += parseInt(rsvpData.pax_planned);
            } else if (rsvpData.status === 'invited') {
                this.data.invited += parseInt(rsvpData.pax_planned);
            } else if (rsvpData.status === 'confirmed') {
                this.data.confirmed += parseInt(rsvpData.pax_planned);
                this.data.confirmedCheckins.pax_planned += parseInt(rsvpData.pax_planned);
                this.data.confirmedCheckins.pax_actual += parseInt(rsvpData.pax_actual);
            } else if (rsvpData.status === 'cancelled') {
                this.data.cancelled += parseInt(rsvpData.pax_planned);
            } else if (rsvpData.status === 'waitlisted') {
                this.data.waitlisted += parseInt(rsvpData.pax_planned);
            }

            this.data.checkins.pax_planned += parseInt(rsvpData.pax_planned);
            this.data.checkins.pax_actual += parseInt(rsvpData.pax_actual);

        }.bind(this));

        this.data.rsvpsCompanions.forEach(function (rsvpData) {
            if (rsvpData.status === 'confirmed') {
                this.data.companions.confirmed += rsvpData.count;
                this.data.companions.confirmedCheckins.pax_planned += parseInt(rsvpData.pax_planned);
                this.data.companions.confirmedCheckins.pax_actual += parseInt(rsvpData.pax_actual);
            }

        }.bind(this));

        this.data.total = this.data.confirmed
            + this.data.cancelled
            + this.data.waitlisted
            + this.data.requested
            + this.data.invited
            + this.data.listed;

        //(confirmed + cancelled + waitlisted + requested + pending) / (overall pax - listed - invited)
        this.data.responded = this.data.total - this.data.listed  - this.data.invited;

        //(confirmed + cancelled + waitlisted + requested + pending) / (overall pax - listed - invited) = response rate
        this.data.percentage = this.data.total > 0 ? Math.round(this.data.responded / this.data.total * 100) : 0;
        this.data.percentageMajority = this.data.percentage > 50 ? 1 : 0;

        //confirmed + waitlisted + requested / overall = interest_rate
        this.data.interest_rate = this.data.total > 0 ? Math.round((this.data.confirmed
            + this.data.requested
            + this.data.waitlisted) / this.data.total * 100)
        : 0;

        // <!--(sum of pax_planned - amount of records + sum of pax_guest) && status==confirmed-->
        this.data.companions_count = this.data.confirmedCheckins.pax_planned - this.data.companions.confirmed;
        //this.data.companions.confirmedCheckins.pax_planned;

        //No-Show Rate (not checked in [confirmed] / confirmed)
        this.data.no_show_rate =  this.data.confirmedCheckins.pax_planned > 0 ? Math.round((this.data.confirmedCheckins.pax_planned - this.data.confirmedCheckins.pax_actual) / this.data.confirmedCheckins.pax_planned * 100) : 0;
    }

    applyAsync() {
        this.scope.$evalAsync();
    }



    resetState() {
        this.data = [];
        this.loading = true;
        this.error = false;
        this.showChart = false;
        this.chartData = {
            labels: [],
            data: [],
            options: {
                scales:
                    {
                        xAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }],
                        yAxes: [{
                            // maxBarThickness: 25
                        }]
                    },
            },
            colors: []
        };
    }
}

ResponseRateController.$inject = [
    '$http',
    '$scope',
    'Env',
    '$stateParams',
    '$rootScope'
];

angular.module('festzelt-os.components')
    .component('guestlistResponseRate', {
        bindings: {
            'guestlistId': '<',
            'refresh': '='
        },
        controller: ResponseRateController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/components/stats/components/guestlists/general/component.js